import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ViewEventDeletionsService {

  baseURL = environment.baseAPIURL;
    constructor( private readonly http  : HttpClient) {
    }

    private handleError(error: HttpErrorResponse) {
      return throwError(error.message || "Server Error");
    }

    loadEventDeletionsData(): Observable<any> {  
        return this.http.get(this.baseURL+'/aetHistory/viewEventDeletion').pipe(catchError(this.handleError));
    }
}
